"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlContextAdapter = void 0;
const on_renderer_context_restored_1 = require("../../events/on-renderer-context-restored");
const on_renderer_context_lost_1 = require("../../events/on-renderer-context-lost");
/**
 * @public
 * Base webgl context adapter. Handles viewport and context loss.
 */
class GlContextAdapter {
    constructor(canvasElement, eventService, ctxId, options) {
        this.canvasElement = canvasElement;
        this.eventService = eventService;
        this.ctxId = ctxId;
        this.options = options;
        this.context = null;
        this.lastCanvasDims = null;
        this.registerEventHandlers();
    }
    onResize(canvasDims) {
        this.lastCanvasDims = canvasDims;
        if (this.context == null) {
            return;
        }
        this.context.viewport(0, 0, canvasDims.pixelDims.getXMax(), canvasDims.pixelDims.getYMax());
    }
    getContext() {
        if (this.context != null) {
            return this.context;
        }
        return this.context = this.canvasElement.getContext(this.ctxId, this.options);
    }
    registerEventHandlers() {
        this.canvasElement.addEventListener("webglcontextlost", (e) => {
            e.preventDefault();
            this.context = null;
            on_renderer_context_lost_1.OnRendererContextLost.emit(this.eventService);
        });
        this.canvasElement.addEventListener("webglcontextrestored", (e) => {
            e.preventDefault();
            this.getContext();
            if (this.lastCanvasDims != null) {
                this.onResize(this.lastCanvasDims);
            }
            on_renderer_context_restored_1.OnRendererContextRestored.emit(this.eventService);
        });
    }
}
exports.GlContextAdapter = GlContextAdapter;
//# sourceMappingURL=gl-context-adapter.js.map